// Imports
import axios from 'axios'

// App Imports
import { API_URL } from '../../../../setup/config/env'
import { MESSAGE_SHOW } from '../../../common/api/actions'
import { MEDIA_GALLERY_LIST_CACHE } from './cache-keys'

import {
  MEDIA_GALLERY_LIST_REQUEST,
  MEDIA_GALLERY_LIST_RESPONSE,
  MEDIA_GALLERY_LIST_DONE
} from './types'


// List all media galleries (admin)
export function list(isLoading = true) {
  return async dispatch => {
    try {
      const list = JSON.parse(window.localStorage.getItem(MEDIA_GALLERY_LIST_CACHE))
      if (list) {
        dispatch({ type: MEDIA_GALLERY_LIST_RESPONSE, list })
      } else {
        dispatch({ type: MEDIA_GALLERY_LIST_REQUEST, isLoading })
      }
    } catch {
      dispatch({ type: MEDIA_GALLERY_LIST_REQUEST, isLoading })
    }

    try {
      const { data } = await axios.post(API_URL, {
        operation: 'mediaGalleryList'
      })

      if (!data.success) {
        dispatch({
          type: MESSAGE_SHOW,
          success: data.success,
          message: data.message
        })
      } else {
        const list = data.data
        dispatch({ type: MEDIA_GALLERY_LIST_RESPONSE, list })
        window.localStorage.setItem(MEDIA_GALLERY_LIST_CACHE, JSON.stringify(list))
      }
    } catch (error) {
      dispatch({
        type: MESSAGE_SHOW,
        success: false,
        message: error.message
      })
    } finally {
      dispatch({
        type: MEDIA_GALLERY_LIST_DONE,
        isLoading: false
      })
    }
  }
}

// Get detail by ID (admin)
export function detail({ mediaGalleryId }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'mediaGalleryDetail',
      params: { mediaGalleryId }
    })
  }
}

// Get by name (public)
export function getByName(name) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'mediaGalleryByName',
      params: { name }
    })
  }
}

// Get all categories
export function getCategories() {
  return axios.post(API_URL, {
    operation: 'mediaGalleryCategoryList',
  });
}

//Get media items by category
export function listByCategory({ mediaGalleryCategoryId }) {
  return axios.post(API_URL, {
    operation: 'mediaGalleryByCategory',
    params: { mediaGalleryCategoryId },
  });
}

